import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/options-strategy-builder',
  component: () => import('../../routes/OptionsStrategyBuilder.svelte'),
  card: {
    id: 'options-strategy-builder',
    title: 'Options Strategy Builder',
    description: 'Build multi-leg option strategies and analyze combined P/L, break-evens, and aggregate portfolio Greeks (delta, gamma, theta, vega).',
    icon: 'account_tree',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/options-strategy-builder',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Options Strategy Builder – Multi-Leg P/L & Portfolio Greeks',
    description:
      'Build and analyze multi-leg options strategies. See combined profit/loss diagrams, break-even prices, and aggregate portfolio Greeks including delta, gamma, theta, vega, and rho.',
  },
};

export default meta;
